import { render, staticRenderFns } from "./SmallDetailsLogoOnly.vue?vue&type=template&id=1e6bc25b&scoped=true"
import script from "./SmallDetailsLogoOnly.vue?vue&type=script&lang=ts"
export * from "./SmallDetailsLogoOnly.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SmallDetailsLogoOnly.vue?vue&type=style&index=0&id=1e6bc25b&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./SmallDetailsLogoOnly.vue?vue&type=style&index=1&id=1e6bc25b&prod&scoped=true&lang=scss")
if (style1.__inject__) style1.__inject__(context)
var style2 = require("./SmallDetailsLogoOnly.vue?vue&type=style&index=2&id=1e6bc25b&prod&lang=css")
if (style2.__inject__) style2.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1e6bc25b",
  null
  ,true
)

export default component.exports